// axios, retry-axios use either CanceledError or AbortError, so we will use CanceledError too
export const createCanceledError = () => {
  return new DOMException('canceled', 'CanceledError');
};

export const isCancelledByUserError = (error: unknown) =>
  ['CanceledError', 'AbortError'].includes((error as DOMException)?.name);
